import { Navigate, useSearchParams } from "react-router-dom";
import { normalizeMatchRoomCode } from "../utils/matchRoomCode";
import { PlayerHomePage } from "../features/player-experience";

/**
 * `/` entry: Player Home inside AppShell.
 * Deep-links that need a room redirect to New Lobby `/play` (Create/Join TRA).
 * Live session is entered from Room Waiting (`/room/:code` → `/room/:code/session`).
 * Legacy `/match/:code` deep links redirect to the room session route.
 */
export default function PlatformHomeEntry() {
  const [search] = useSearchParams();
  const tvRaw = search.get("tv");
  const tvCode = tvRaw ? normalizeMatchRoomCode(tvRaw) : "";
  if (tvCode) {
    return <Navigate to={`/tv/${encodeURIComponent(tvCode)}`} replace />;
  }

  const room = search.get("room");
  const roster = search.get("roster");
  const spectator = search.get("spectator");
  if (room || roster) {
    const params = new URLSearchParams();
    if (room) params.set("room", room);
    if (roster) params.set("roster", roster);
    if (spectator) params.set("spectator", spectator);
    const q = params.toString();
    return <Navigate to={q ? `/play?${q}` : "/play"} replace />;
  }

  return <PlayerHomePage />;
}
